import { isPlatformBrowser } from '@angular/common';
import {
  afterNextRender,
  Component,
  inject,
  PLATFORM_ID,
  signal,
  ChangeDetectionStrategy
} from '@angular/core';
import { ARTICLES } from '../../data/articles';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { createPressCollectionSchema } from '../../data/structured-data';

@Component({
  selector: 'app-press',
  imports: [RouterModule],
  templateUrl: './press.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './press.scss',
})
export class Press {
  protected readonly articles = ARTICLES;
  protected readonly isAnimated = signal(false);
  private platformId = inject(PLATFORM_ID);
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle =
    'News from MARI | Global Events, Acquisitions & Company Insights';
  protected readonly seoDescription =
    'Explore press releases and announcements from MARI - global events, art and sports ventures, innovations and more.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      jsonLdBlocks: [createPressCollectionSchema(this.articles)],
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Press', path: '/press' },
      ],
    });

    afterNextRender(() => {
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          this.isAnimated.set(true);
        }, 150);
      }
    });
  }
}
